<script>
import { services } from '@src/utils/common-services'
import { appConfig } from '@src/app.config'

// import DatePicker from 'vue2-datepicker'
// import { BIconLock } from 'bootstrap-vue'

// import { ValidationObserver } from 'vee-validate'

export default {
  components: {
    //  BIconLock,
    // Layout,
    //   DatePicker,
    // ValidationObserver,
  },
  page: {
    title: 'Candidate List',
    meta: [{ name: 'description', content: `Candidate ${appConfig.title}` }],
  },

  data() {
    return {
      firstName: null,
      surame: null,
      phone: null,
      email: null,
      counts: 0,
      gender: null,
      title: null,
      select: null,
      dateOfBirth: null,
      location: null,
      canvas: null,
      editApplicantData: null,
      currenProfile: null,
      minimizeFooter: false,
      message: null,
      tablist: null,
      showSuccess: false,
      createApplicantMenu: false,
      deleteApplicantMenu: false,
      editApplicantfMenu: false,
      createApplicant: false,
      editApplicant: true,
      oldPassword: null,
      newPassword: null,
      trySpin: false,
      menuToggle: null,
      classToggle: false,
      validateName: { required: true },
      validatePhone: {
        required: true,
        regex: /^(\+)?[\d]{9,13}$/,
      },
      validateEmail: { disabled: true, email: true },

      validateOldPassword: null,
      validateNewPassword: null,

      preloader: false,
    }
  },
  computed: {
    placeholders() {
      return {
        fname: 'First Name',
        surname: 'Last Name',
        phone: 'Enter phone number',
        email: 'Enter email address',
      }
    },
  },

  watch: {
    classToggle(val, oldVal) {
      if (val !== oldVal) {
        this.scrollToTop()
        if (this.createApplicant === false) this.createApplicant = true
      }
    },
    menuToggle(val, oldVal) {
      if (val !== oldVal) {
        //   console.log('here')
        //  this.setMenubar({ newVal: true })
        this.$root.$emit('open', this.menuToggle)
      }
    },
    oldPassword: function(val, oldval) {
      if (val !== oldval) {
        this.validateOldPassword = null
        this.validateNewPassword = null
      }
    },
    newPassword: function(val, oldval) {
      if (val !== oldval) {
        this.validateNewPassword = null
        this.validateOldPassword = null
      }
    },
    firstName: function(val, oldval) {
      if (val !== oldval) {
      }
    },
    lastName: function(val, oldval) {
      if (val !== oldval) {
      }
    },

    phone: function(val, oldval) {
      if (val !== oldval) {
      }
    },
    file: function(val, oldVal) {
      if (this.file !== null) {
        const reader = new FileReader()
        reader.readAsDataURL(this.file)
        var parent = this
        setTimeout(() => {
          var ImageURL = reader.result

          parent.imageToCrop = ImageURL
        }, 1000)
      }
    },
    createApplicant(oldVal, newVal) {
      if (oldVal !== newVal) {
        if (!this.createApplicant) {
          this.editApplicantData = null
        } else this.tablist = null
      }
    },
  },
  mounted: function() {
    //  this.$refs.circle.animate(1.0)
    // console.log(state.userDetails)
    // this.profile = services.getCandidatesNameIcon(state.userDetails)
  },
  beforeDestroy() {
    this.$off('applicant')
    this.$off('create')
    this.$off('view')
    this.$store.commit('jv/clearRecords', { _jv: { type: 'invite' } })
    this.$store.commit('jv/clearRecords', {
      _jv: { type: 'applicant_profile' },
    })
    var doc = this.$refs.candidate
    if (doc !== undefined) doc.innerHTML = ''
  },
  beforeMount() {
    // this.getUser()
    // this.currentProfile = JSON.parse(window.localStorage.getItem('currentUser'))
    // (this.currentUser.type).toUpperCase()
    // this.percentage = 60 // this.currentUser.percentage

    this.img = null // this.currentUser.avatar
    var check = this.$store.getters['jv/get']('menu_list')
    var id = Object.keys(check)

    this.actions = services.searchActions(
      'Applicants',
      check[id]._jv.attrs.config
    )

    if (this.actions !== undefined) {
      if (this.actions.indexOf('create') !== -1) this.createApplicantMenu = true
      if (this.actions.indexOf('edit') !== -1) this.editApplicantfMenu = true
      if (this.actions.indexOf('delete') !== -1) this.deleteApplicantMenu = true
    } else this.$router.push({ name: '404' })
  },

  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    viewList() {
      this.createApplicant = !this.createApplicant
      this.tablist = 'all'
      this.counts++
    },
    getDataToEdit(id) {
      var data = this.$store.getters['jv/get']('applicant_profile')
      this.editApplicantData = data[id.id]
      this.editApplicantData['id'] = id.id
      this.createApplicant = true
    },
  },
}
</script>

<template>
  <div ref="candidate">
    <StaffBaseCreateCandidate
      v-if="createApplicant"
      :key="createApplicant"
      :edit="editApplicantData"
      @view="viewList"
    />

    <StaffBaseCandidateList
      v-else
      :key="counts"
      :tab="tablist"
      :edit-menu="editApplicantfMenu"
      :delete-menu="deleteApplicantMenu"
      @edit="editApplicant"
      @create="createApplicant = $event"
      @applicant="getDataToEdit"
    />
    <footer id="footer" :class="$style.footerWraper">
      <div
        :class="
          minimizeFooter
            ? [$style.responsiveFooter, $style.mimimize]
            : [$style.responsiveFooter]
        "
      >
        <div class="position-relative">
          <a
            :class="$style.footerMinimize"
            class="position-absolute"
            @click="minimizeFooter = !minimizeFooter"
            ><BIcon icon="grip-vertical"></BIcon
          ></a>
          <b-container fluid>
            <b-row>
              <b-col cols="4" sm="4">
                <button
                  :class="[$style.footerMenu, $style.menu]"
                  @click="menuToggle = !menuToggle"
                  ><BIcon class="" icon="grid"></BIcon>
                  <span :class="$style.footerMenuTxt">Menu</span>
                </button>
              </b-col>
              <b-col cols="4" sm="4">
                <button
                  :class="[$style.footerMenu, $style.dashboard]"
                  @click="$router.push({ name: 'dashboard' })"
                >
                  <BIcon icon="grid1x2"></BIcon>
                  <span :class="$style.footerMenuTxt">Dashboard</span>
                </button>
              </b-col>
              <b-col cols="4" sm="4">
                <button
                  :class="
                    !createApplicant
                      ? [$style.footerMenu, $style.settings]
                      : [$style.footerMenu, $style.settings, $style.selected]
                  "
                  @click="classToggle = !classToggle"
                >
                  <BIcon class="" icon="person-plus"></BIcon>
                  <span :class="$style.footerMenuTxt">Invite Applicant</span>
                </button>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <div class="clear"></div>
    </footer>
  </div>
</template>
<style lang="scss" module>
@import '@design';
</style>
